export enum GROUPS {
    General = "general",
    LogFiles = "log files",
    CanObd = "canObd",
    FeatureControl = "feature control",
    Carrier = "carrier"
}

export enum PAYLOAD_ID {
    FileId = "file_id",
    Attributes = "attributes"
}

export enum TX_FIRMWARE_BANNER_TYPES {
    DowngradeProtection,
    Unsupported
}

export enum SCHEDULE_TASK_TYPE {
    ByDate = "by date",
    ByTime = "by time"
}
